module.exports = __webpack_public_path__ + "img/logo.1072f496.png";